import type { PrimeVuePTOptions } from 'primevue/config';

export const ChipDesign: Pick<PrimeVuePTOptions, 'chip'> = {
    chip: {
        root: { class: 'w-fit p-0 m-0 bg-ds-primary-100 round text-center rounded-full' },
        label: { class: 'px-3 truncate' },
    },
};
